import type { CSSProperties, ReactNode } from "react";
import type { MediaItemId, SceneId } from "./dolcetto-media-data";

export function MediaItem({
  id,
  scene,
  activeWidth,
  activeHeight,
  flatLeft,
  flatTop,
  flatWidth,
  flatHeight,
  flatOpacity,
  children,
  z = 5,
}: {
  id: MediaItemId;
  scene: SceneId;
  activeWidth: string;
  activeHeight: string;
  flatLeft: string;
  flatTop: string;
  flatWidth: string;
  flatHeight: string;
  flatOpacity?: number;
  children: ReactNode;
  z?: number;
}) {
  const style = {
    "--active-width": activeWidth,
    "--active-height": activeHeight,
    "--flat-left": flatLeft,
    "--flat-top": flatTop,
    "--flat-width": flatWidth,
    "--flat-height": flatHeight,
    "--flat-opacity": flatOpacity ?? 1,
    "--z": z,
  } as CSSProperties;

  return (
    <div
      className="dolcetto-media-item"
      data-media-id={id}
      data-active={scene === id}
      style={style}
    >
      {children}
    </div>
  );
}
